import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { baseStyles } from '@/styles';

@customElement('fg-configurator-error')
@localized()
export class FgConfiguratorError extends LitElement {
  render() {
    return html`
      <p>${t('errors.productNotFound')}</p>
    `;
  }

  static styles = [baseStyles];
}
